import React from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { UseMutateAsyncFunction } from "@tanstack/react-query";
import {
  useScreenshotRectangleStore,
  useWidePopupStore,
} from "../../../api/Zustand";
import { CloseIcon } from "../../Icons/gui-elements-icons";

type prompt = {
  role: string;
  content: string;
  image?: string;
};

const img =
  "https://fastly.picsum.photos/id/519/400/400.jpg?hmac=gmNjAgyH3hznjcjYTuNOwjhBeOpuEGanXWGQMipWWJQ";

function adaptResultToBase64(res: Blob): Promise<string> {
  let reader: FileReader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onloadend = () => {
      resolve(reader.result as string);
    };
    reader.onerror = () => {
      reject("Error reading file.");
    };
    reader.readAsDataURL(res);
  });
}

async function urlToBlob(url: string): Promise<Blob> {
  const res = await fetch(url);
  const blob = await res.blob();
  return blob;
}

const PromptSubmitter = (props: {
  mutateAsync: UseMutateAsyncFunction<any, Error, string, unknown>;
  visionMutateAsync: UseMutateAsyncFunction<
    any,
    Error,
    {
      image: string;
      prompt?: string | undefined;
    },
    unknown
  >;
  isPending: boolean;
}) => {
  const { visionMutateAsync, mutateAsync } = props;

  const { register, handleSubmit, reset, watch, setValue } = useForm<prompt>({
    defaultValues: { role: "user" },
  });

  const hasImage = watch("image");

  const { setTakingScreen } = useWidePopupStore();

  const { image: screenshot, resetImage } = useScreenshotRectangleStore();

  const formRef = React.useRef<HTMLFormElement>(null);

  const onSubmit: SubmitHandler<prompt> = (data) => {
    if (data.image) {
      visionMutateAsync({ image: data.image, prompt: data.content });
      reset();
      resetImage();
    } else {
      reset();
      mutateAsync(data.content);
    }
  };

  React.useEffect(() => {
    if (screenshot) {
      setValue("content", "Cosa vedi in questa immagine?");

      setValue("image", screenshot);
    }
  }, [screenshot, setValue]);

  return (
    <form
      autoComplete="off"
      style={{
        minHeight: "70px",
        display: "flex",
        width: "full",
        gap: "20px",
        alignItems: "center",
        position: "relative",
      }}
      ref={formRef}
      onSubmit={handleSubmit(onSubmit)}
    >
      <div
        style={{
          width: 300,
          height: 300,
          position: "absolute",
          top: -300,
        }}
      ></div>

      <div style={{ flex: 1 }}>
        <input
          maxLength={2048}
          {...register("content", { required: true })}
          type="text"
          id="gpt"
          placeholder="Invia un prompt"
        ></input>

        {/* <input type="submit" id="gpt" /> */}
      </div>
      <button
        title="genera dalla panoramica"
        type="button"
        id="gpt"
        onClick={() => setTakingScreen(true)}
        disabled={props.isPending}
      >
        {screenGrabIcon}
      </button>

      <button type="submit" id="gpt" disabled={props.isPending}>
        {sendIcon}
      </button>
      {!!hasImage && (
        <div
          style={{
            position: "absolute",
            top: -160,
            width: 150,
            height: 150,
            background: "#444",
            padding: 5,
          }}
        >
          <img
            src={hasImage}
            alt="tst"
            style={{
              opacity: 0.8,
              overflow: "hidden",
              height: 150,
              width: 150,
              objectFit: "cover",
            }}
          />
          <button
            type="button"
            onClick={() => {
              resetImage();
              setValue("image", undefined);
            }}
            className="close-img-prompt"
          >
            <CloseIcon fill="white" height="1.4rem" width="1.4rem" />
          </button>
        </div>
      )}
      {/* <textarea
        disabled={isPending}
        style={{
          resize: "none",
          border: "1px solid tomato",
          height: "100px",

          fontWeight: 600,
          boxSizing: "border-box",
          outline: "none",
          width: "100%",
        }}
        {...register("content", { required: true })}
      ></textarea> */}
    </form>
  );
};

export default PromptSubmitter;

const sendIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="32"
    viewBox="0 -960 960 960"
    width="32"
  >
    <path d="M120-160v-640l760 320-760 320Zm60-93 544-227-544-230v168l242 62-242 60v167Zm0 0v-457 457Z" />
  </svg>
);

const imageIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
  >
    <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm40-80h480L570-480 450-320l-90-120-120 160Zm-40 80v-560 560Z" />
  </svg>
);

const screenGrabIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="32"
    viewBox="0 -960 960 960"
    width="32"
  >
    <path d="M680-80v-120H560v-80h120v-120h80v120h120v80H760v120h-80ZM200-200v-200h80v120h120v80H200Zm0-360v-200h200v80H280v120h-80Zm480 0v-120H560v-80h200v200h-80Z" />
  </svg>
);
